module.exports = __webpack_public_path__ + "8d50d65e65217281fc52d84d70c56fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dinners_club.png
// module id = 517
// module chunks = 0